module.exports = __webpack_public_path__ + "static/concept4-pc-239454aede055bce763e3eb87a02ae57.svg";